export default __webpack_public_path__ + "locales/uk-UA/DownloadDialog.json?hash=2e7da9baeff2a5efe006374eb59c2d5b";